module.exports = __webpack_public_path__ + "static/media/align-left.b5239908.svg";